import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b06bcbb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = { class: "reinstatement-invoice-creation-status" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"text-decoration":"underline"} }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Success!")
], -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Reinstatement invoice has been generated. ")
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "reinstatement-invoice-details"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Invoice amount", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Insured email", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Broker billing email", -1))
const _hoisted_19 = {
  key: 1,
  class: "reinstatement-invoice-payment-status"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Invoice status", -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_22 = {
  key: 0,
  class: "paid-label"
}
const _hoisted_23 = {
  key: 1,
  class: "unpaid-label"
}
const _hoisted_24 = {
  key: 2,
  class: "reinstatement-invoice-link"
}
const _hoisted_25 = ["href"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Invoice details", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { key: 4 }
const _hoisted_29 = { class: "reinstatement-creation-status" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { key: 2 }
const _hoisted_33 = { key: 3 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"text-decoration":"underline"} }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Success!")
], -1))
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Policy has been reinstated. ")
const _hoisted_36 = [
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = {
  key: 5,
  class: "reinstatement-section"
}
const _hoisted_38 = { class: "eligibility-section" }
const _hoisted_39 = {
  key: 0,
  class: "eligible-label"
}
const _hoisted_40 = {
  key: 1,
  class: "ineligible-label"
}
const _hoisted_41 = /*#__PURE__*/_createTextVNode()
const _hoisted_42 = { class: "ineligible-reason" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Cancellation history:", -1))
const _hoisted_45 = { class: "cancellation-field" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Cancellation effective", -1))
const _hoisted_47 = { class: "cancellation-field" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Reason", -1))
const _hoisted_49 = ["disabled"]
const _hoisted_50 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isLoadingReinstatement)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Loading reinstatement info..."))
      : _createCommentVNode("", true),
    (_ctx.hasReinstatementLoadingError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Failed to load reinstatement info"))
      : _createCommentVNode("", true),
    (!_ctx.hasPolicies)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, " This account has no quotes or policies associated with it. "))
      : _createCommentVNode("", true),
    ((_ctx.hasInitiatedInvoiceCreation || _ctx.hasPendingReinstatements) && !_ctx.hasInitiatedReinstatementCreation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.isLoadingNewInvoice)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Loading..."))
              : _createCommentVNode("", true),
            (_ctx.hasInvoiceCreationErrorBop && !_ctx.isLoadingNewInvoice)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Error generating BOP reinstatement invoice!"))
              : _createCommentVNode("", true),
            (_ctx.hasInvoiceCreationErrorXs && !_ctx.isLoadingNewInvoice)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Error generating XS reinstatement invoice!"))
              : _createCommentVNode("", true),
            (!_ctx.hasInvoiceCreationErrorBop && !_ctx.hasInvoiceCreationErrorXs && !_ctx.isLoadingNewInvoice)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _hoisted_12))
              : _createCommentVNode("", true)
          ]),
          (_ctx.hasPendingReinstatements)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _hoisted_14,
                _createTextVNode(": $" + _toDisplayString(_ctx.reinstatementInvoice.amountDue), 1),
                _hoisted_15,
                _hoisted_16,
                _createTextVNode(": " + _toDisplayString(_ctx.accountContact), 1),
                _hoisted_17,
                _hoisted_18,
                _createTextVNode(": " + _toDisplayString(_ctx.getFinanceAdminsReadable(_ctx.financeAdminInfo)), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.hasPendingReinstatements)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _hoisted_20,
                _hoisted_21,
                (_ctx.hasPaidReinstatements)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString('Paid')))
                  : _createCommentVNode("", true),
                (!_ctx.hasPaidReinstatements)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString('Unpaid')))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.hasPendingReinstatements)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createElementVNode("a", {
                  href: _ctx.reinstatementInvoiceLink,
                  target: "_blank"
                }, _hoisted_27, 8, _hoisted_25)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasInitiatedReinstatementCreation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            (_ctx.isReinstatingPolicy)
              ? (_openBlock(), _createElementBlock("span", _hoisted_30, "Loading..."))
              : _createCommentVNode("", true),
            (_ctx.hasReinstatementCreationErrorBop && !_ctx.isReinstatingPolicy)
              ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Error reinstating BOP policy!"))
              : _createCommentVNode("", true),
            (_ctx.hasReinstatementCreationErrorXs && !_ctx.isReinstatingPolicy)
              ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Error reinstating XS policy!"))
              : _createCommentVNode("", true),
            (!_ctx.hasReinstatementCreationErrorBop && !_ctx.hasReinstatementCreationErrorXs && !_ctx.isReinstatingPolicy)
              ? (_openBlock(), _createElementBlock("span", _hoisted_33, _hoisted_36))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.reinstatementInfo && !_ctx.hasInitiatedInvoiceCreation && !_ctx.hasPendingReinstatements)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            (_ctx.isEligible)
              ? (_openBlock(), _createElementBlock("span", _hoisted_39, "ELIGIBLE"))
              : _createCommentVNode("", true),
            (!_ctx.isEligible)
              ? (_openBlock(), _createElementBlock("span", _hoisted_40, "INELIGIBLE:"))
              : _createCommentVNode("", true),
            _hoisted_41,
            _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.ineligibleReason), 1)
          ]),
          (_ctx.cancellations)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cancellations, (cancellation) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: cancellation.cancellationDate,
                      class: "cancellation-section"
                    }, [
                      _createElementVNode("span", _hoisted_45, [
                        _hoisted_46,
                        _createTextVNode(": " + _toDisplayString(cancellation.cancellationDate), 1)
                      ]),
                      _createElementVNode("span", _hoisted_47, [
                        _hoisted_48,
                        _createTextVNode(": " + _toDisplayString(_ctx.getCancellationLabel(cancellation.reason)), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasPolicies && !_ctx.hasReinstatementLoadingError && !_ctx.hasInitiatedInvoiceCreation && !_ctx.hasPendingReinstatements)
      ? (_openBlock(), _createElementBlock("button", {
          key: 6,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createInvoice())),
          disabled: !_ctx.isEligible,
          id: "js-create-invoice"
        }, " Create invoice ", 8, _hoisted_49))
      : _createCommentVNode("", true),
    (_ctx.hasPolicies && !_ctx.hasReinstatementLoadingError && _ctx.hasInitiatedInvoiceCreation && _ctx.hasPendingReinstatements && !_ctx.hasInitiatedReinstatementCreation)
      ? (_openBlock(), _createElementBlock("button", {
          key: 7,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reinstatePolicy())),
          disabled: !_ctx.hasPaidReinstatements,
          id: "js-reinstate-policy"
        }, " Reinstate policy ", 8, _hoisted_50))
      : _createCommentVNode("", true)
  ]))
}